export default {
    CREATE_NODE: "Создание объекта"
};
